import { byRanking } from "./byRanking";

// Ritorna il grupppo principale se esiste, altrimenti torna il primo
export function getPrincipaleOPrimoGruppo(aggregate) {
	let principale = aggregate.find(ag => ag?.isPrincipale);
	return principale || aggregate.sort(byRanking)[0];
}
